// Asset API
export async function getImages() {
    try {
        const response = await fetch(window.uploadUrl, {
            headers: {
                "X-CSRF-TOKEN": window.csrfToken,
            },
        });
        if (!response.ok) {
            throw new Error("Couldn't fetch assets");
        }
        const images = await response.json();

        localStorage.setItem("images", JSON.stringify(images.assets));

        return JSON.parse(localStorage.getItem("images") || "[]");
    } catch (error) {
        throw ("Fetch error:", error);
    }
}

export async function saveImage(file) {
    const formData = new FormData();
    formData.append("image", file);

    try {
        const response = await fetch(window.uploadUrl, {
            method: "post",
            body: formData,
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken,
            },
        });

        if (response.ok) {
            console.log("Image uploaded successfully");
        } else {
            console.error("Image upload failed:", response.statusText);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }
}

export async function deleteImage(id) {
    try {
        const response = await fetch(`${window.uploadUrl}/${id}`, {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken,
            },
        });

        if (!response.ok) {
            console.log("Image uploaded successfully");
        } else {
            console.error("Image upload failed:", response.statusText);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }
}

// Font API
export async function getFonts() {
    try {
        const response = await fetch(window.fontUrl,
            {
                headers: {
                    "X-CSRF-TOKEN": window.csrfToken,
                }
            });
        if (!response.ok) {
            console.log(response)
            throw new Error("Couldn't fetch assets");
        }
        const res = await response.json();
        localStorage.setItem("fonts", JSON.stringify(res.fonts));

        return JSON.parse(localStorage.getItem("fonts") || "[]");
    } catch (error) {
        throw ("Fetch error:", error);
    }
}

export async function saveFonts(file) {
    const formData = new FormData();
    formData.append("font", file);

    try {
        const response = await fetch(window.fontUrl, {
            method: "post",
            body: formData,
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken,
            },
        });

        if (response.ok) {
            console.log("Font uploaded successfully");
        } else {
            console.error("Font upload failed:", response.statusText);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }
}

export async function deleteFont(name) {
    try {
        const response = await fetch(`${window.fontUrl}/${name}`, {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": window.csrfToken,
            },
        });

        if (!response.ok) {
            const result = await response.json();
            console.log("Font deleted successfully");
        } else {
            console.error("Font deleted failed:", response.statusText);
        }
    } catch (error) {
        console.error("Delete error:", error);
    }
}
